window.$catalog_users_result = [];
window.$catalog_users_didUpdateChange = true;
window.$catalog_users_treeChangeStatus = false;
window.$catalog_users_treeList = [];
window.$catalog_users_page_number = 1;
window.$catalog_users_newInsertId = [];
window.$catalog_users_Glist = [];
window.$catalog_users_content = [];
window.$catalog_users_user_alias = [];
window.$catalog_users_user_email = [];
window.$catalog_users_gebruikersrollen = [];
window.$catalog_users_organisatie = [];
window.$catalog_users_selectedRow = [];
window.$catalog_users_gvv = 1;
window.$catalog_users_filterMaatregelenIsActive = [];
window.$catalog_users_filterPlannigIsActive = [];
window.$catalog_users_filterContent = [];
window.$catalog_users_filterClickStatus = false;
window.$catalog_users_scroll_change = false;
window.$catalog_users_columnList = [];
window.$catalog_users_selectedIds = null;
window.$catalog_users_token = null;
window.$catalog_users_refresh = function (){};
window.$catalog_users_columnListPure = null;

window.$catalog_users_lastUsedTableFilter = {
  content: [],
  definitions: [],
};

window.$catalog_users_actions = [];
window.$catalog_users_total_row = 0;
window.$catalog_users_real_total_row = 0;
window.$catalog_users_column_order_post_model = {
  client_identification: "",
  code: "",
  data: {
    table_sorting: [
      {
        name: "catalog>gebruikersbeheer",
        column_list: [
          "checkbox",
          "active",
          "Alias",
          "Email",
          "Gebruikersrollen",
          "Organisatie",
          "Mandate organisatie",
          "Geldig van",
        ],
      },
    ],
  },
};
